import { messwertLog, messwertLogGeflaggt, messstelle, messwertLogGeflaggtStatus } from "../../utils/apiTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../../app/store";
import { messwertelisteState } from "./datenvollstaendigkeitTypes";
import { getWithAuth, postJsonWithAuth, postWithAuth } from '../../utils/api';
import { logError, nanosecondsTimeStampToDate, transformDataToApexAxisChartSeriesMesswerte, subtractTimezoneOffset } from "../../utils/utils";
import { BarChartData } from "../../features/chart/chartTypes";
import { errorHandler } from "../../utils/errorHandling";

const seriesDataDummy: ApexAxisChartSeries =
    [{
        name: "Aufgezeichnete Daten",
        data: [
        ]
    },
    {
        name: "Keine Daten",
        data: [
        ]
    },
    {
        name: "Fehler",
        data: [
        ]
    }]

const initialState: messwertelisteState
    = {
    aktuellerWert: Array<messstelle>(),
    tempAktuellerWert: Array<messstelle>(),
    messstellenListe: Array<messstelle>(),
    barChart: {
        height: 150,
        series: seriesDataDummy
    },
    showGraph: false,
    loadingMessstellen: false,
    loadingMesswerte: false,
    showDatePicker: false,
    startDatum: new Date(),
    endDatum: new Date(),
    tempstartDatum: new Date(),
    tempEndDatum: new Date(),
    ersteDatum: new Date(),
    letzteDatum: new Date(),
    initBool: true,
    selectedZeitraum: "30T"
};

const datenvollstaendigkeitSlice = createSlice({
    name: "datenvollstaendigkeit",
    initialState,
    reducers:
    {
        setTempAktuellerWert: (state, action: PayloadAction<messstelle[]>) => {
            state.tempAktuellerWert = action.payload;
        },
        setAktuellerWert: (state, action: PayloadAction<messstelle[]>) => {
            state.aktuellerWert = action.payload;
        },
        setAllMessstellenTempAktuellerWert: (state) => {
            if (state.initBool) {
                state.tempAktuellerWert = state.messstellenListe;
                state.initBool = false;
            }
        },
        setMessstellen: (state, action: PayloadAction<messstelle[]>) => {
            state.messstellenListe = action.payload;
        },
        setStartdatum: (state, action: PayloadAction<Date>) => {
            state.startDatum = action.payload;
        },
        setEndedatum: (state, action: PayloadAction<Date>) => {
            state.endDatum = action.payload;
        },
        setTempStartdatum: (state, action: PayloadAction<Date>) => {
            state.tempstartDatum = action.payload;
        },
        setTempEndedatum: (state, action: PayloadAction<Date>) => {
            state.tempEndDatum = action.payload;
        },
        setLetztedatum: (state, action: PayloadAction<Date>) => {
            state.letzteDatum = action.payload;
        },
        setErstedatum: (state, action: PayloadAction<Date>) => {
            state.ersteDatum = action.payload;
        },
        setMessstellenLoading: (state, action: PayloadAction<boolean>) => {
            state.loadingMessstellen = action.payload;
        },
        setMesswerteLoading: (state, action: PayloadAction<boolean>) => {
            state.loadingMesswerte = action.payload;
        },
        setShowGraph: (state, action: PayloadAction<boolean>) => {
            state.showGraph = action.payload;
        },
        setShowDatePicker: (state, action: PayloadAction<boolean>) => {
            state.showDatePicker = action.payload;
        },
        setSelectedZeitraum: (state, action: PayloadAction<string>) => {
            state.selectedZeitraum = action.payload
        },
        selectFilteredMessstellenOfGroup: (state, action: PayloadAction<{ groups: Array<string> | null, filter: string }>) => {
            const filter = action.payload.filter.toLowerCase();
            if (action.payload.groups) {
                const grouplessMessstellen = state.tempAktuellerWert.filter(x => !action.payload.groups?.includes(x.umspannwerk))
                    .filter(x => state.messstellenListe.filter(m => m.umspannwerk == x.umspannwerk).length != state.tempAktuellerWert.filter(m => m.umspannwerk == x.umspannwerk).length);
                state.tempAktuellerWert = state.messstellenListe.filter(x => x.umspannwerk ? action.payload.groups?.includes(x.umspannwerk) : false);
                state.tempAktuellerWert = state.tempAktuellerWert.concat(grouplessMessstellen);
                state.tempAktuellerWert = state.tempAktuellerWert.filter(x => x.name.toLowerCase().includes(filter) || x.schaltfeld.toLowerCase().includes(filter) || x.umspannwerk.toLowerCase().includes(filter));
            } else {
                state.tempAktuellerWert = state.messstellenListe.filter(x => x.name.toLowerCase().includes(filter) || x.schaltfeld.toLowerCase().includes(filter) || x.umspannwerk.toLowerCase().includes(filter));
            }
        },
        setBarChartProperties: (state, action: PayloadAction<{ start: PayloadAction<Date>, ende: PayloadAction<Date>, messwerte: Array<messwertLog>, messwerteGeflaggt: Array<messwertLogGeflaggt> }>) => {
            state.startDatum = action.payload.start.payload;
            state.endDatum = action.payload.ende.payload;
            if (state.aktuellerWert.length <= 1) {
                state.barChart.height = 150;
            } else
                state.barChart.height = 150 + (state.aktuellerWert.length * 30);
        },
        clearBarChartSeriesData: (state) => {
            state.barChart.series = seriesDataDummy;
        },
        addBarChartSeriesData: (state, action: PayloadAction<ApexAxisChartSeries>) => {
            /* eslint-disable @typescript-eslint/no-explicit-any */
            action.payload[0].data.forEach((x: any) => state.barChart.series[0].data.push(x));
            action.payload[1].data.forEach((x: any) => state.barChart.series[1].data.push(x));
            action.payload[2].data.forEach((x: any) => state.barChart.series[2].data.push(x));
            /* eslint-enable @typescript-eslint/no-explicit-any */
        }
    },
});

//Selectors
export const selectAktuellerWert = (state: RootState): messstelle[] =>
    state.datenvollstaendigkeit.aktuellerWert;
export const selectTempAktuellerWert = (state: RootState): messstelle[] =>
    state.datenvollstaendigkeit.tempAktuellerWert;
export const selectMessstellen = (state: RootState): messstelle[] =>
    state.datenvollstaendigkeit.messstellenListe;
export const selectStartDatum = (state: RootState): Date =>
    state.datenvollstaendigkeit.startDatum;
export const selectEndeDatum = (state: RootState): Date =>
    state.datenvollstaendigkeit.endDatum;
export const selectTempStartDatum = (state: RootState): Date =>
    state.datenvollstaendigkeit.tempstartDatum;
export const selectTempEndeDatum = (state: RootState): Date =>
    state.datenvollstaendigkeit.tempEndDatum;
export const selectErsteDatum = (state: RootState): Date =>
    state.datenvollstaendigkeit.ersteDatum;
export const selectLetzteDatum = (state: RootState): Date =>
    state.datenvollstaendigkeit.letzteDatum;
export const selectMesswerteLoading = (state: RootState): boolean => state.datenvollstaendigkeit.loadingMesswerte;
export const selectMessstellenLoading = (state: RootState): boolean => state.datenvollstaendigkeit.loadingMessstellen;
export const selectShowGraph = (state: RootState): boolean => state.datenvollstaendigkeit.showGraph;
export const selectShowDatePicker = (state: RootState): boolean => state.datenvollstaendigkeit.showDatePicker;
export const selectBarChartData = (state: RootState): BarChartData => state.datenvollstaendigkeit.barChart;
export const selectSelectedZeitraum = (state: RootState): string => state.datenvollstaendigkeit.selectedZeitraum;

//Actions
export const {
    setAktuellerWert,
    setTempAktuellerWert,
    setMessstellenLoading,
    setMesswerteLoading,
    setMessstellen,
    selectFilteredMessstellenOfGroup,
    setStartdatum,
    setEndedatum,
    setTempEndedatum,
    setTempStartdatum,
    setErstedatum,
    setLetztedatum,
    setShowGraph,
    setShowDatePicker,
    setAllMessstellenTempAktuellerWert,
    setBarChartProperties,
    setSelectedZeitraum,
    clearBarChartSeriesData,
    addBarChartSeriesData,
} = datenvollstaendigkeitSlice.actions;

export const getMessstellen = (isUTCType: boolean) => (
    dispatch: AppDispatch
): void => {
    dispatch(setMessstellenLoading(true));
    getWithAuth("MESSSTELLE", {}).then((response: messstelle[]) => {
        const messstelleHatDaten: messstelle[] = response.filter((e) => e.hatDaten);
        dispatch(setMessstellen(messstelleHatDaten));
        //dispatch(setAllMessstellenTempAktuellerWert());
        dispatch(getFirstLastTimeStampMesswert(messstelleHatDaten));

        //init Zeitraum
        const from = new Date();
        const now = new Date();
        from.setMonth(now.getMonth() - 1);
        dispatch(setTempStartdatum(isUTCType ? subtractTimezoneOffset(from) : from));
        dispatch(setTempEndedatum(isUTCType ? subtractTimezoneOffset(now) : now));

    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMessstellenLoading(false)));
}

export const getFirstLastTimeStampMesswert = (messstellen: messstelle[]) => (
    dispatch: AppDispatch
): void => {

    const messstellenNamenListe = messstellen.map(e => e.name);

    postWithAuth("FIRSTANDLASTMESSWERT",
        {
            hersteller: "Eberle",
            klasse: "c10m",
        },
        messstellenNamenListe.join(","))
        .then(messwerteResponse => {
            dispatch(setErstedatum(nanosecondsTimeStampToDate(messwerteResponse.firstTimeStamp)));
            dispatch(setLetztedatum(nanosecondsTimeStampToDate(messwerteResponse.lastTimeStamp)));

        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        });
};

export const getGraph = (messstellen: messstelle[], startDatum: Date, endeDatum: Date, messstellenDict: Record<string, messstelle>) => (
    dispatch: AppDispatch
): void => {
    dispatch(setMesswerteLoading(true));
    dispatch(clearBarChartSeriesData());
    const promiseMesswert: Promise<Array<messwertLog>> =
        postWithAuth("MESSWERTLOG", {
            hersteller: "Eberle",
            datenklasse: "c10m",
            from: startDatum,
            to: endeDatum,

        }, messstellen.map(x => x.name).join(","));

    const promiseMesswertGeflaggt: Promise<Array<messwertLogGeflaggt>> =
        postJsonWithAuth("POSTMESSWERTEGEFLAGGT", {},
            {
                start: startDatum,
                end: endeDatum,
                messstellen: messstellen.map(x => x.name),
                status: [messwertLogGeflaggtStatus.verworfen]
            });

    Promise.all([promiseMesswert, promiseMesswertGeflaggt]).then(([messwerteResponse, messwerteGeflaggtResponse]: [Array<messwertLog>, Array<messwertLogGeflaggt>]) => {
        const transformedData = transformDataToApexAxisChartSeriesMesswerte(messwerteResponse, messwerteGeflaggtResponse, startDatum, endeDatum, messstellenDict);
        dispatch(addBarChartSeriesData(transformedData));
        dispatch(setMesswerteLoading(false));
        dispatch(setBarChartProperties({ start: { payload: startDatum, type: "" }, ende: { payload: endeDatum, type: "" }, messwerte: messwerteResponse, messwerteGeflaggt: messwerteGeflaggtResponse }));
    }).catch((error) => {
        logError(error);
        dispatch(setMesswerteLoading(false));
        errorHandler(error, dispatch);
    });


};

export default datenvollstaendigkeitSlice.reducer;